import React from 'react'
import { Link } from 'react-router-dom'

const AppDevelopmentCostingGuide = ({ title, costPath, image }) => {
  const appName = title.replace(/ App Development$/, '')

  return (
    <section className="container py-5 text-light">
      <div className="row align-items-center g-4 rounded-4 p-4 p-lg-5" style={{ background: 'linear-gradient(135deg, #20222d 0%, #12131a 100%)', border: '1px solid rgba(101,101,255,.4)' }}>
        <div className="col-lg-7">
          <p className="h5 fw-bold mb-3" style={{ color: '#8f8fff', letterSpacing: 1.2 }}>COSTING GUIDE</p>
          <h2 className="display-6 fw-bold">{appName} App Development Costing Guide</h2>
          <p className="lead text-light text-opacity-75 mb-4">
            A useful estimate connects features, integrations, platform coverage, security, and launch expectations to the work required. Explore the factors that shape a realistic {appName.toLowerCase()} app budget before committing to a build.
          </p>
          <Link to={costPath} className="btn btn-primary rounded-pill px-4" onClick={() => window.scrollTo(0, 0)}>
            View details <i className="fa fa-arrow-right ms-2" aria-hidden="true" />
          </Link>
        </div>
        <div className="col-lg-5">
          <img src={image} className="w-100 rounded-4" style={{ aspectRatio: '4 / 3', objectFit: 'cover' }} loading="lazy" alt={`${appName} app development cost planning illustration`} />
        </div>
      </div>
    </section>
  )
}

export default AppDevelopmentCostingGuide
